const fields = {
  config: { columns: 1 },
  fields: [

    {
      name: "tmpId",
      column: 1,
      type: "unvisible",
    },
    {
      name: 'dates',
      label: 'Ważny od do',
      column: 1,
      type: 'dateRange',
      mandatory: true,
      startField: 'startDate',
      endField: 'endDate',
      excludedDates: [],
      excludedStartDates: [],
      excludedEndDates: [],
      mamndatory:true,
      fromLabel: 'Data startu',
      toLabel: 'Data końca',
    },
    {
      name: 'priceList',
      label: 'Cennik',
      column: 1,
      mandatory: true,
      type: 'dictionary',
      dictionary: 'price-list',
    },
  ],
};

export default fields;
